'use client';

import { useEffect, useState } from 'react';

import CalendlyModal from '@/components/CalendlyModal';
import { LocationApplicationLeadDto } from '@/lib/leads';
import {
  createLocationApplicationLeadDto,
  isCalendlyPreLoadable,
} from '@/lib/leads/leads';
import { SimpleLocationDto } from '@/lib/locations/dto';
import { getAppropiateCalendlyLink } from '@/utils/calendly';
import { shallowEqual } from '@/utils/object-utils';

import ApplicationForm from '../../../location-form/_components/ApplicationForm';
import {
  ApplicationFormData,
  TourType,
} from '../../../location-form/_components/types';
import { getAvailableTourTypes } from '../../../location-form/_components/utils';
import { useLeadCreation } from '../useLeadCreation';

type WorkspaceFormProps = {
  allLocations: SimpleLocationDto[];
};

export function WorkspaceForm({ allLocations }: WorkspaceFormProps) {
  const [location, setLocation] = useState<SimpleLocationDto>();
  const availableTourTypes = location && getAvailableTourTypes(location);
  const [tourType, setTourType] = useState<TourType>(TourType.IN_PERSON);
  const {
    isLoading,
    isCalendlyDisplayed,
    handleFormSubmitted,
    handleCalendlyModalSubmitted,
  } = useLeadCreation(location);
  const [form, setForm] = useState<ApplicationFormData>();
  const [lead, setLead] = useState<LocationApplicationLeadDto>();
  const calendlyLink = location && getAppropiateCalendlyLink(location);

  useEffect(() => {
    setTourType(
      availableTourTypes?.some(({ type }) => type === TourType.IN_PERSON)
        ? TourType.IN_PERSON
        : TourType.VIRTUAL
    );
  }, [location]);

  const handleLocationChange = (sfId: string) => {
    setLocation(allLocations.find((x) => x.sfId === sfId));
  };

  const handleFormChange = (formChanged: ApplicationFormData) => {
    if (
      isCalendlyPreLoadable(formChanged) &&
      (!form || !shallowEqual(form, formChanged))
    ) {
      setForm(formChanged);
    }
  };

  return (
    <>
      <ApplicationForm
        showLocationSelection
        location={location}
        allLocations={allLocations}
        selectedTourType={tourType}
        onLocationChange={handleLocationChange}
        onTourTypeChange={setTourType}
        onChange={handleFormChange}
        onSubmit={(form) => {
          const lead = createLocationApplicationLeadDto(form);
          setLead(lead);
          handleFormSubmitted(lead);
        }}
        isLoading={isLoading}
        availableTourTypes={availableTourTypes}
      />
      {calendlyLink && form && (
        <CalendlyModal
          link={calendlyLink}
          company={form.company}
          email={form.email}
          firstName={form.firstName}
          lastName={form.lastName}
          phone={form.phone}
          opened={isCalendlyDisplayed}
          onClose={() => handleCalendlyModalSubmitted(lead!)}
          onSubmit={() => handleCalendlyModalSubmitted(lead!)}
        />
      )}
    </>
  );
}
